<script setup lang="ts">
import { post, setToken, showLoading } from "@/utils";
import { onMounted } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

onMounted(async () => {
  const ins = showLoading("正在初始化");
  const { success, data } = await post("MpStartup/LoadMpStartupSetting", {
    flag: import.meta.env.VITE_APP_FLAG,
  });

  ins.hide();
  if (!success) {
    return;
  }

  setToken(data.token);

  router.replace({
    path: "/page",
    query: { args: encodeURIComponent(data.routeParams) },
  });
});
</script>
